var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('div',{staticClass:"Auth",class:{
            '--gradient':_setup.useGradient,
            '--reverse-gradient':_setup.reverseGradient
        }},[_c(_setup.Overlay),_c('div',{staticClass:"Auth__logo"},[_c('img',{attrs:{"src":_setup.logo,"alt":""}})]),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }